"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntrepotCacheDatabase = void 0;
const common_1 = require("@augment-vir/common");
const dexie_1 = __importDefault(require("dexie"));
const delete_database_1 = require("./delete-database");
const databaseName = 'EntrepotDatabase';
class InternalEntrepotDatabaseClass extends dexie_1.default {
    constructor() {
        super(databaseName);
        this.version(4).stores({
            /** & designates the unique key: https://dexie.org/docs/Version/Version.stores() */
            nriCache: '&rowKey',
            collectionsStatsCache: '&rowKey',
            allBaseCollectionsCache: '&rowKey',
        });
    }
}
const putTestKey = `dummy-entrepot-row-entry-testing-data`;
async function createDatabase() {
    try {
        const database = new InternalEntrepotDatabaseClass();
        // query all the tables to make sure they work
        database.nriCache.toArray();
        await database.nriCache.put({
            data: undefined,
            rowKey: putTestKey,
        });
        await database.nriCache.delete(putTestKey);
        database.collectionsStatsCache.toArray();
        await database.collectionsStatsCache.put({
            data: undefined,
            rowKey: putTestKey,
        });
        await database.collectionsStatsCache.delete(putTestKey);
        database.allBaseCollectionsCache.toArray();
        await database.allBaseCollectionsCache.put({
            data: [],
            rowKey: putTestKey,
        });
        await database.allBaseCollectionsCache.delete(putTestKey);
        return database;
    }
    catch (error) {
        /** If there was an error for some reason, just reset the database. */
        console.warn(`Resetting cache database due to error from creating database: ${(0, common_1.extractErrorMessage)(error)}`);
        await (0, delete_database_1.deleteDatabase)(databaseName);
        return new InternalEntrepotDatabaseClass();
    }
}
const entrepotCacheDatabase = createDatabase();
async function getEntrepotCacheDatabase() {
    return await entrepotCacheDatabase;
}
exports.getEntrepotCacheDatabase = getEntrepotCacheDatabase;
